module.exports = __webpack_public_path__ + "img/131.1.9df1d40b.jpg";